import styled from 'styled-components'

export const FieldValue = styled.span`
    font-size: 14px;
    font-family: Work Sans;
    margin-left: 0.4rem;
    font-weight: 400;
`

export const Field = styled(FieldValue)`
    font-weight: bold;
`
